import { useFetchEmployee } from "@/queries/useFetchEmployee.ts";
import { CircularProgress, Typography } from "@mui/material";

type Props = {
    employeeUUID: string;
};

const EmployeeDisplay = ({ employeeUUID }: Props) => {
    const { data, isError, isRefetching, isLoading, error } = useFetchEmployee(employeeUUID);

    if (isError) {
        return <Typography variant={"h5"}>Error loading employee: {error.message}</Typography>;
    }

    if (isLoading || isRefetching) {
        return <CircularProgress size={"12px"} />;
    }

    return (
        <Typography
            variant={"body1"}
        >{`${data?.data.nameFirst} ${data?.data.nameLast}`}</Typography>
    );
};

export default EmployeeDisplay;
